
/**
 * OMFE Components Loader
 * - can be used via window.OMFE.ComponentLoader.load(...)
 */

// @TODO: unload
// @TODO: loadedComponents

export { load, unload } from './ComponentLoader';



// WEBPACK FOOTER //
// ./src/ComponentLoader/index.js